import { render, staticRenderFns } from "./CancellationTab.vue?vue&type=template&id=315f7806&scoped=true&"
import script from "./CancellationTab.vue?vue&type=script&lang=js&"
export * from "./CancellationTab.vue?vue&type=script&lang=js&"
import style0 from "./CancellationTab.vue?vue&type=style&index=0&id=315f7806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f7806",
  null
  
)

export default component.exports